
import { Options, Vue } from "vue-class-component";
import { PropType } from "vue";
import { AssetsInterface } from "@/types";
import { hasAccessToAsset } from "@/utils/assetAccessChecker";
import { useMq } from "vue3-mq";

@Options({
  name: "AssetDescription",
  props: {
    asset: {
      type: Object as PropType<AssetsInterface>,
      required: true,
    },
  },
  emits: ["close"],
})
export default class AssetDescription extends Vue {
  asset!: AssetsInterface;

  protected hasAccessToAsset = hasAccessToAsset;
  private mq = useMq();

  protected get hasDescription(): boolean {
    return !!this.asset?.description;
  }

  private calculateMaxHeight(): void {
    this.$nextTick(() => {
      const isDesktop = ["lg", "xl", "xxl"].includes(this.mq.current);
      const panel = this.$refs.panel as HTMLElement;

      if (!panel) {
        return;
      }

      const panelRect = panel.getBoundingClientRect();
      let availableHeight = panelRect.height - 47 - 38 - 30;

      if (!isDesktop) {
        availableHeight = panelRect.height - 12 - 38 - 30;
      }

      panel.style.setProperty('--max-panel-height', `${availableHeight}px`);
    });
  }

  private handleResize(): void {
    this.$emit('close');
  }

  mounted(): void {
    this.calculateMaxHeight();
    window.addEventListener('resize', this.handleResize);
  }

  beforeUnmount(): void {
    window.removeEventListener('resize', this.handleResize);
  }
}
